import { AdTaskProcessStep } from "../entitys";
// 不要修改为@/cdn 会有循环依赖问题
import { TASK_DETAIL_TIP_PRODUCT } from "@/cdn/task-detail";

export const FulfillmentContentList = [
  {
    title: "Fulfillment Product:",
    valueList: ["Perfume Spray"],
  },
  {
    title: "Fulfillment Deliverable:",
    valueList: ["TikTok Link"],
  },
  {
    title: "Fulfillment Content Requirements:",
    valueList: [
      "Creator must appear on camera",
      "Product details must be clearly shown",
    ],
  },
];

export const CollaborationContentList = [
  "After fulfilling on time, the system will automatically review it.",
  "Once approved, you will be contacted for payment.",
  "If the review takes too long, please proactively contact customer service to check the progress.",
];

export const TaskDetailTabList = [
  {
    id: "productOverview",
    label: "Product Overview",
    targetId: "productOverview",
  },
  {
    id: "yfAdTaskRules",
    label: "YF Ad task rules",
    targetId: "yfAdTaskRules",
  },
  {
    id: "featuresRequirements",
    label: "Features & Requirements",
    targetId: "featuresRequirements",
  },
  {
    id: "collaborationDetails",
    label: "Collaboration Details",
    targetId: "collaborationDetails",
  },
  {
    id: "joinProcess",
    label: "Join Process",
    targetId: "joinProcess",
  },
];

export const TaskNoSampleProcessSteps = [
  {
    step: "Step1",
    description: "Join Task",
  },
  {
    step: "Step2",
    description: "Mashup video",
  },
  {
    step: "Step3",
    description: "Post video",
  },
  {
    step: "Step4",
    description: "Earn Bonus",
  },
];

export const TaskSampleProcessSteps = [
  {
    step: "Step1",
    description: "Join Task",
  },
  {
    step: "Step2",
    description: "Request sample",
  },
  {
    step: "Step3",
    description: "Post video",
  },
  {
    step: "Step4",
    description: "Earn Bonus",
  },
];

export const AdTasksTipInfo = {
  task_id: "1027916694221551",
  bonus_earned_str: "$60.00",
  creator_avatar_list: [],
  creator_commission_rate_str: "15%",
  current_gmv: 0,
  gmv_rule: 0,
  join_video_number: 6,
  name: "test commission-qliin",
  pay_price_str: "$30k",
  product_cover: TASK_DETAIL_TIP_PRODUCT,
  product_id: "1729452980169183452",
  product_name:
    "GuruNanda Whitening Strips, 7-day treatment (7 Packets - 2 Strips per pack)- Enamel-Safe Strips for Sensitive Teeth - Non-Slip, Dry Strip Technology",
  task_type: 1,
  video_number: 10,
  viewers: 2000,
};

export const TaskNoSampleProcessStepsV2: AdTaskProcessStep[] = [
  {
    step: "Step1",
    description: "Join Task",
  },
  {
    step: "Step2",
    description: "Create Video",
    showIcon: true,
  },
  {
    step: "Step3",
    description: "Post video",
  },
  {
    step: "Step4",
    description: "Earn Bonus",
  },
];

export const TaskSampleProcessStepsV2: AdTaskProcessStep[] = [
  {
    step: "Step1",
    description: "Join Task",
  },
  {
    step: "Step2",
    description: "Request sample",
  },
  {
    step: "Step3",
    description: "Post video",
  },
  {
    step: "Step4",
    description: "Earn Bonus",
  },
];
